import { Component } from '@angular/core';

import { ActivitiesBaseComponent } from '../../activities.base.service';

@Component({
  selector: 'app-activities-downloaded',
  templateUrl: './activities-downloaded.component.html',
  styleUrls: ['./activities-downloaded.component.scss'],
})
export class ActivitiesDownloadedComponent extends ActivitiesBaseComponent {}
